import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-polyglot';
import isEqual from 'lodash/isEqual';

import OfflineBooks from '../OfflineBooks';
import SingleSelectSubHeader from '../SingleSelectSubHeader'

import { 
  unsaveOfflineWorkflow, 
  onTabChange,
  unsaveOfflineTranslationsWorkflow
} from '../../redux/offlineBooksActions'
import {
  applyFilter, resetFilters
} from "../../redux/allFiltersActions";

import { gaEventLabel, gaEventActions, offlineBooksUrl, readingProgram, flpHome, stemHome} from '../../lib/constants';
import { getImageSize } from '../../lib/images';
import { addSlimNotification } from '../../redux/slimNotificationActions';
import { fetchAssetsForOfflineTranslateWorkflow, openOfflineTranslator } from '../../redux/bookActions';
import rtl from '../RTLProvider/rtl';
import sortBy from 'lodash/sortBy';
import { openAuthModal } from './../../redux/userActions';
import SvgIcon from '../SvgIcon';
import classNames from 'classnames';

const OfflineAccordion = ({ open, isRtl, baseClassName, title, language, toggle, onApplyFilter, appliedFilters, books}) => {
  const handleClick = (val) => {
    onApplyFilter('language', val);
    toggle()
  }

  const countClasses = {
    [`${baseClassName}__count-el`]: true,
    [`${baseClassName}__count-el--active`]: true,
    [`${baseClassName}__count-el--active-rtl`]: isRtl
  }

  return (
    <div className = {isRtl ? `${baseClassName}__offline-filter ${baseClassName}__offline-filter--rtl`: `${baseClassName}__offline-filter`}>
    <div className = {`${baseClassName}__offline-filter-box`}>
      <p className = {`${baseClassName}__offline-filter-box--text`}>{title}</p>
      <div className = {`${baseClassName}__offline-filter-box--icon`}  onClick={()=>toggle()}>
        {language && language.find(el=>el.queryValue === appliedFilters.language[0]) && <p className = {`${baseClassName}__offline-filter--lang`}>{language.find(el=>el.queryValue === appliedFilters.language[0]).name}</p>}
        <SvgIcon name={'down-arrow'} />
      </div>
      {books && books.filter(book =>book.locale === appliedFilters.language[0]) && books.filter(book =>book.locale === appliedFilters.language[0]).length > 0 && <div className={classNames(countClasses)}>{books.filter(book =>book.locale === appliedFilters.language[0]).length}</div>}
    </div>
    {open && language &&  
    <div className={`${baseClassName}__offline-filter--options`}>
      {language.map(el => <div className={el.queryValue === appliedFilters.language[0] ? `${baseClassName}__offline-filter--active` :'' } onClick={()=> handleClick(el.queryValue)}>{el.name}
       {books && books.filter(book =>book.locale === el.queryValue) && books.filter(book =>book.locale === el.queryValue).length > 0 && <p className={`${baseClassName}__count-el`}>{books.filter(book =>book.locale === el.queryValue).length}</p>}
      </div>)}
    </div>
    }
  </div>
  )
}

const mapStateToProps = state => {
  return {
    viewport: state.viewport,
    books: state.offlineBooks.books,
    online: state.network.online,
    userEmail: state.user.profile.email,
    windowDimensions: state.windowDimensions,
    userId: state.user.profile.id,
    userType: state.user.profile.profile_type,
    activeTabIndex: state.offlineBooks.activeTabIndex,
    offlineTranslations: state.offlineBooks.translations,
    isOfflineTranslatorVisible: state.book.isOfflineTranslatorVisible,
    isFetchingMe: state.user.isFetchingMe,
    isLoggedIn: state.user.isLoggedIn
  }
}

const mapDispatchToProps = {
  unsaveOfflineWorkflow,
  addSlimNotification,
  onTabChange,
  fetchAssetsForOfflineTranslateWorkflow,
  openOfflineTranslator,
  unsaveOfflineTranslationsWorkflow,
  applyFilter,
  resetFilters,
  openAuthModal,
}

const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get('language') || 'en';

@rtl
@connect(mapStateToProps, mapDispatchToProps)
class OfflineBooksContainer extends Component {
  constructor(props) {
    super(props);
    this.enableEditMode = this.enableEditMode.bind(this);
    this.disableEditMode = this.disableEditMode.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onChangeCheckedValues = this.onChangeCheckedValues.bind(this);
    this.onChangeCheckedTranslateValues = this.onChangeCheckedTranslateValues.bind(this);
    this.state = {
      editActive: false,
      checkedValues: [],
      themeCheckedValues: [],
      flpCheckedValues: [],
      stemCheckedValues: [],
      checkedTranslateValues: [],
      appliedFilters:{
        language: ['en']
      },
      rpLanguageSelectedBooks: [],
      themeCount: 0,
      rpOfflineBooks: [],
      rpLang: 'en',
      open: false
    }
  }
componentDidUpdate(prevProps, prevState, snapshots){
    if(this.props !== prevProps){
        if(this.props.books !== prevProps.books){
          let urlParams = new URLSearchParams(window.location.search);
          let language = urlParams.get('language') || 'en';
          this.componentOnLoad(language)
        }
        if(this.props.isLoggedIn !== prevProps.isLoggedIn && this.props.isLoggedIn) {
          this.componentOnLoad(lang)
        }
    }
}

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoggedIn) {

      if (localStorage.getItem("offlineTranslateRedirect")) {
        this.props.addSlimNotification({
          type: 'info',
          content: this.props.t('OfflineTranslate.draft-redirect-notification')
        })
        localStorage.removeItem("offlineTranslateRedirect")
      }
    }
  }

  componentDidMount() {
    window.addEventListener('load', this.componentOnLoad(lang));
  }

  onTabChangeUrl = (index, language) => {
    let requiredLang = language ? language : (offlineBooksUrl[index] === "flp-home" ? "hi" : "en")
    this.props.onTabChange({ activeTabIndex: parseInt(index, 10) });
    this.props.history.replace(`/offline/${offlineBooksUrl[index]}`);
    this.onApplyFilter('language', requiredLang, true)
    let el = document.getElementsByClassName("pb-tabs__tab-link--active")
    if (el[0]) el[0].scrollIntoViewIfNeeded()
  }

  getLanguage = (l, books = null) => {
    let langs = [];
    switch(this.props.match.params.slug) {
      case "flp-home": langs = Object.values(flpHome.siteHeaderLinks).map(el => el.value);
                        break;
      case "stem-home": langs = Object.values(stemHome.siteHeaderLinks).map(el => el.value);
                        break;
      case "reading-programme": langs = Object.values(readingProgram.siteHeaderLinks).map(el => el.value);
                        break;  
      default: langs = [];
    }

    if(books) {
      let bookLangs = books.map(el => el.locale)  
      if(langs.includes(l) && bookLangs.includes(l))
        return l
      else return bookLangs[0]
    }
    else {
      if(langs.includes(l))
        return l
      else return langs[0]
    }    
  }

  componentOnLoad = (language) => {
    let currUserId = this.props.userId || localStorage.getItem('userId');
    if (currUserId) {
      if (Object.entries(this.props.match.params).length === 0) {
        if (this.props.books.filter(book => currUserId && book.savedUsers && book.isFromOfflineTranslate && book.savedUsers.includes(parseInt(currUserId, 10))).length !== 0) {
          this.onTabChangeUrl(4, language)
        }
        else 
        if (this.props.books.filter(book => currUserId && book.savedUsers && book.isFromStemHome && book.savedUsers.includes(parseInt(currUserId, 10))).length !== 0) {
          this.onTabChangeUrl(3, this.getLanguage(language, this.props.books.filter(book => currUserId && book.savedUsers && book.isFromStemHome && book.savedUsers.includes(parseInt(currUserId, 10)))))
        }
        else if (this.props.books.filter(book => currUserId && book.savedUsers && book.isFromFlpHome && book.savedUsers.includes(parseInt(currUserId, 10))).length !== 0) {
          this.onTabChangeUrl(2, this.getLanguage(language, this.props.books.filter(book => currUserId && book.savedUsers && book.isFromFlpHome && book.savedUsers.includes(parseInt(currUserId, 10)))))
        }
        else if (this.props.books.filter(book => currUserId && book.savedUsers && book.isFromReadingProgram && book.savedUsers.includes(parseInt(currUserId, 10))).length !== 0) {
          this.onTabChangeUrl(1, this.getLanguage(language, this.props.books.filter(book => currUserId && book.savedUsers && book.isFromReadingProgram && book.savedUsers.includes(parseInt(currUserId, 10)))))
        }
        else {
          this.onTabChangeUrl(0, language)
        }
      }
      else {
        this.onTabChangeUrl(offlineBooksUrl.indexOf(this.props.match.params.slug) !== -1 ? offlineBooksUrl.indexOf(this.props.match.params.slug) : 0, this.getLanguage(language))
      }
    }else{
      this.props.history.replace(`/offline`);
    }
  }

  enableEditMode() {
    this.setState({
      editActive: true
    })
    this.onTriggerEvents({
      gtmLabel: gaEventLabel.allTabs,
      gtmAction: gaEventActions.removeStories,
    })
  }

  disableEditMode() {
    this.setState({
      editActive: false,
      checkedValues: [],
      themeCheckedValues: [],
      flpCheckedValues: [],
      stemCheckedValues: [],
      checkedTranslateValues: []
    })
  }

  onChangeCheckedValues(checkedValues) {
    if(!isEqual(this.state.checkedValues, checkedValues) )
    this.setState({checkedValues: checkedValues.slice()})
  }

  onChangeCheckedThemeValues = ({ checked, value }) => {
    if (checked) {
      this.setState({
        themeCheckedValues: [].concat(this.state.themeCheckedValues, value)
      })
    } else {
      this.setState({
        themeCheckedValues: this.state.themeCheckedValues.filter( tc => tc !== value)
      })
    }
  }

  onChangeCheckedFlpValues = ({ checked, value }) => {
    if (checked) {
      this.setState({
        flpCheckedValues: [].concat(this.state.flpCheckedValues, value)
      })
    } else {
      this.setState({
        flpCheckedValues: this.state.flpCheckedValues.filter( tc => tc !== value)
      })
    }
  }

  onChangeCheckedStemValues = ({ checked, value }) => {
    if (checked) {
      this.setState({
        stemCheckedValues: [].concat(this.state.stemCheckedValues, value)
      })
    } else {
      this.setState({
        stemCheckedValues: this.state.stemCheckedValues.filter( tc => tc !== value)
      })
    }
  }

  onReadingTabDelete = () => {
    const {  userId, books ,  unsaveOfflineWorkflow , windowDimensions } = this.props;
   // in offline mode, get userId from localStorage
    const profileId = userId || parseInt(localStorage.getItem('userId'), 10);
    const readingProgramBooks = books.filter(book => profileId && book.savedUsers && book.isFromReadingProgram && book.savedUsers.includes(parseInt(profileId, 10)))

    const checkedThemeBooks = readingProgramBooks.filter(book => this.state.themeCheckedValues.includes(book.themeName.concat(book.fluencyId)))

    const unsaveBooksPromise = checkedThemeBooks
      .map(book => {
        // delete book.isFromReadingProgram;
        return unsaveOfflineWorkflow(book, getImageSize(windowDimensions.width), profileId)
      })

    Promise.all(unsaveBooksPromise).then(() => {
      localStorage.setItem('sw-offline-activity', 'offline' + Math.random());
    })
    this.setState({
      editActive: false,
      checkedValues: [],
      themeCheckedValues: [],
      flpCheckedValues: [],
      stemCheckedValues: [],
      checkedTranslateValues: []
    })
  }

  onFlpTabDelete = () => {
    const {  userId, books ,  unsaveOfflineWorkflow , windowDimensions } = this.props;
   // in offline mode, get userId from localStorage
    const profileId = userId || parseInt(localStorage.getItem('userId'), 10);
    const flpBooks = books.filter(book => profileId && book.savedUsers && book.isFromFlpHome && book.savedUsers.includes(parseInt(profileId, 10)))

    const checkedThemeBooks = flpBooks.filter(book => this.state.flpCheckedValues.includes(book.themeName.concat(book.fluencyId)))

    const unsaveBooksPromise = checkedThemeBooks
      .map(book => {
        // delete book.isFromReadingProgram;
        return unsaveOfflineWorkflow(book, getImageSize(windowDimensions.width), profileId)
      })

    Promise.all(unsaveBooksPromise).then(() => {
      localStorage.setItem('sw-offline-activity', 'offline' + Math.random());
    })
    this.setState({
      editActive: false,
      checkedValues: [],
      themeCheckedValues: [],
      flpCheckedValues: [],
      checkedTranslateValues: []
    })
  }

  onStemTabDelete = () => {
    const {  userId, books ,  unsaveOfflineWorkflow , windowDimensions } = this.props;
   // in offline mode, get userId from localStorage
    const profileId = userId || parseInt(localStorage.getItem('userId'), 10);
    const stemHomeBooks = books.filter(book => profileId && book.savedUsers && book.isFromStemHome && book.savedUsers.includes(parseInt(profileId, 10)))

    const checkedStemBooks = stemHomeBooks.filter(book => this.state.stemCheckedValues.map(el=>parseInt(el, 10)).includes(book.lpId))
    const unsaveBooksPromise = checkedStemBooks
      .map(book => {
        // delete book.isFromReadingProgram;
        return unsaveOfflineWorkflow(book, getImageSize(windowDimensions.width), profileId, book.lpId)
      })

    Promise.all(unsaveBooksPromise).then(() => {
      localStorage.setItem('sw-offline-activity', 'offline' + Math.random());
    })
    this.setState({
      editActive: false,
      checkedValues: [],
      themeCheckedValues: [],
      flpCheckedValues: [],
      stemCheckedValues: [],
      checkedTranslateValues: []
    })
  }

  onChangeCheckedTranslateValues(checkedTranslateValues) {
    if(!isEqual(this.state.checkedTranslateValues, checkedTranslateValues)) {
      this.setState({checkedTranslateValues: checkedTranslateValues.slice()})
    }
  }

  onDelete() {
    const { unsaveOfflineWorkflow, books, userId, windowDimensions, unsaveOfflineTranslationsWorkflow, activeTabIndex } = this.props;

    // Find the selected books for deletion
    let checkedBooks = [];
    if(activeTabIndex === 4) {
      this.state.checkedTranslateValues.forEach(value => { 
        const book = this.props.offlineTranslations.find(translation => value.bookId === translation.id && value.userId === translation.userId && value.targetLanguage === translation.targetLanguage);
        checkedBooks.push(book);
      });
    }
    else if(activeTabIndex === 3) { //stem tab
      checkedBooks = books.filter(book => book.isFromStemHome && this.state.checkedValues.includes(book.id));
    }
    else if(activeTabIndex === 2) { //flp tab
      checkedBooks = books.filter(book => book.isFromFlpHome && this.state.checkedValues.includes(book.id));
    }
    else if(activeTabIndex === 1) { //reading programme tab
      checkedBooks = books.filter(book => book.isFromReadingProgram && this.state.checkedValues.includes(book.id));
    }
    else if(activeTabIndex === 0) { // read tab
      checkedBooks = books.filter(book => !book.isFromReadingProgram &&  !book.isFromFlpHome && !book.isFromOfflineTranslate && !book.isFromStemHome && this.state.checkedValues.includes(book.id));
    }

    // in offline mode, get userId from localStorage
    const profileId = userId || parseInt(localStorage.getItem('userId'), 10);
    const unsaveBooksPromise = checkedBooks.map(book => {
      if(book.isFromOfflineTranslate) {
        return unsaveOfflineTranslationsWorkflow(book, getImageSize(windowDimensions.width), profileId, book.targetLanguage);
      }
      return unsaveOfflineWorkflow(book, getImageSize(windowDimensions.width), profileId, book.isFromStemHome ? book.lpId : null)
    });
    
    Promise.all(unsaveBooksPromise).then(() => {
      localStorage.setItem('sw-offline-activity', 'offline' + Math.random());

      this.setState({
        editActive: false,
        checkedValues: [],
        themeCheckedValues: [],
        flpCheckedValues: [],
        stemCheckedValues: [],
        checkedTranslateValues: []
      })
    })
  }

  openOfflineTranslation = (book) => {
    const {
      t,
      viewport,
      addSlimNotification,
      fetchAssetsForOfflineTranslateWorkflow,
      openOfflineTranslator,
      userId
    } = this.props;

    if (viewport.medium) {
      fetchAssetsForOfflineTranslateWorkflow(book.slug)
      .then(response => {
        if ( response ) {
          openOfflineTranslator({book,  startPage: response.data.frontStoryPagePosition , userId});
        }
      })
    }
    else {
      addSlimNotification({
        id: 'Book.mobile-editor-notification',
        content: t('Book.mobile-editor-notification-text'),
      });
    }    
  }

  onApplyFilter = (type, value, flag) => {
    const tabList = ['read', 'reading_program', 'FLP_merge', 'STEM', 'translate']
    const {applyFilter, activeTabIndex} = this.props;
    let appliedArr = {language: this.state.appliedFilters.language};
    appliedArr.language = [value];
    this.setState({appliedFilters: appliedArr})
    this.setState({rpLang: value});
    if (window.location.pathname.includes('reading-programme') || window.location.pathname.includes('flp-home') || window.location.pathname.includes('stem-home')) {
      this.props.history.replace(`?language=${value}`)
    }
    applyFilter({ filter: value, filterType: type });

    if (!flag) {
      this.onTriggerEvents({
        gtmLabel: `${tabList[activeTabIndex]}_tab`,
        gtmAction: gaEventActions.clickedLanguage,
        itemType: gaEventLabel.language,
        itemValue: value,
      })
    }
  }

  removeFilter = (type, value) => {
  }

  onTriggerEvents = (obj) => {
    const { userType, userId} = this.props;
    const {gtmAction, gtmLabel, itemType, itemValue} = obj;

    window.dataLayer.push({
      'category': gaEventLabel.offlineLibrary,
      ...(gtmLabel && { 'label': gtmLabel }),
      ...(gtmAction && { 'event': gtmAction }),
      'item_type': itemType || null,
      'item_value': itemValue || null,
      'item_id': null,
      'user_profile': userType,
      'user_id': userId || '00000'
    })
  }

  toggle = () => {
    this.setState({
      open: !this.state.open
    });
  }
  
  render() {
    const { t, viewport, online, activeTabIndex, onTabChange, isOfflineTranslatorVisible, userEmail, userType, openAuthModal } = this.props;
    const userId = this.props.userId || localStorage.getItem('userId');
    const books = this.props.books.filter(book => userId && book.savedUsers && book.savedUsers.includes(parseInt(userId, 10)));
    const readBooks = this.props.books.filter(book => userId && book.savedUsers && !book.isFromReadingProgram && !book.isFromFlpHome && !book.isFromStemHome && !book.isFromOfflineTranslate && book.savedUsers.includes(parseInt(userId, 10)))
    const readingProgramBooks = this.props.books.filter(book => userId && book.savedUsers && book.isFromReadingProgram && book.savedUsers.includes(parseInt(userId, 10)))
    const flpHomeBooks = this.props.books.filter(book => userId && book.savedUsers && book.isFromFlpHome && book.savedUsers.includes(parseInt(userId, 10)))
    const checkedThemeBooks = readingProgramBooks.filter(book => this.state.themeCheckedValues.includes(book.themeName.concat(book.fluencyId)))
    const { editActive, checkedValues , themeCheckedValues, flpCheckedValues,  stemCheckedValues, checkedTranslateValues } = this.state;
    const offlineTranslateBooks = this.props.offlineTranslations.filter(offlineTranslation => offlineTranslation.userId === parseInt(userId, 10));
    const stemHomeBooks = this.props.books.filter(book => userId && book.savedUsers && book.isFromStemHome && book.savedUsers.includes(parseInt(userId, 10)))
    const stemLpData =[]
    let filtersComponent = null;
    let flpHomeFiltersComponent = null;
    let stemHomeFiltersComponent = null;
    let {appliedFilters} = this.state;
    
    const filters = {
      language: {
        "name": "Language",
        "queryKey": "language",
        "sourceLanguage": "English",
        "targetLanguage": "",
        "queryValues": Object.values(readingProgram.siteHeaderLinks).filter(val=> val.label === "English").concat(sortBy(Object.values(readingProgram.siteHeaderLinks).filter(val => val.label !== "English"), val => val.label))
        .map(val => (
          {name: val.label,
          queryValue: val.value
           }
        ))
      }
    }

    const flpHomeFilters = {
      language: {
        "name": "Language",
        "queryKey": "language",
        "sourceLanguage": "English",
        "targetLanguage": "",
        "queryValues": Object.values(flpHome.siteHeaderLinks).filter(val=> val.label === "English").concat(sortBy(Object.values(flpHome.siteHeaderLinks).filter(val => val.label !== "English"), val => val.label))
        .map(val => (
          {
            name: val.label,
            queryValue: val.value
          }
        ))
      }
    }

    const stemHomeFilters = {
      language: {
        "name": "Language",
        "queryKey": "language",
        "sourceLanguage": "English",
        "targetLanguage": "",
        "queryValues": Object.values(stemHome.siteHeaderLinks).filter(val=> val.disable === false).map(
          val => ({
            name: val.label,
            queryValue: val.value
          })
        )
      }
    }

    if(viewport.medium){
      filtersComponent = (
        <SingleSelectSubHeader
         t={t} 
         onApplyFilter={this.onApplyFilter}
         languages={filters.language.queryValues}
         selectedLanguage={appliedFilters.language[0]}
         isRtl={this.props.isRtl}
         books = {readingProgramBooks}
         />
          )
    }
    else {
      filtersComponent = (
        <OfflineAccordion
          baseClassName={'pb-offline-books'}
          open={this.state.open}
          isRtl={this.props.isRtl}
          title={t("global.reading-program-select-language")}
          language={filters.language.queryValues}
          toggle={this.toggle}
          onApplyFilter={this.onApplyFilter}
          appliedFilters={appliedFilters}
          books = {readingProgramBooks}
        />
      )
    }

    if(viewport.medium){
      flpHomeFiltersComponent = (
        <SingleSelectSubHeader
         t={t} 
         onApplyFilter={this.onApplyFilter}
         languages={flpHomeFilters.language.queryValues}
         selectedLanguage={appliedFilters.language[0]}
         isRtl={this.props.isRtl}
         books = {flpHomeBooks}
         />
          )
    }
    else {
      flpHomeFiltersComponent = (
        <OfflineAccordion
          baseClassName={'pb-offline-books'}
          open={this.state.open}
          isRtl={this.props.isRtl}
          title={t("global.reading-program-select-language")}
          language={flpHomeFilters.language.queryValues}
          toggle={this.toggle}
          onApplyFilter={this.onApplyFilter}
          appliedFilters={appliedFilters}
          books = {flpHomeBooks}
        />
      )
    }

    if(viewport.medium){
      stemHomeFiltersComponent = (
        <SingleSelectSubHeader
         t={t} 
         onApplyFilter={this.onApplyFilter}
         languages={stemHomeFilters.language.queryValues}
         selectedLanguage={appliedFilters.language[0]}
         isRtl={this.props.isRtl}
         books = {stemHomeBooks}
         />
          )
    }
    else {
      stemHomeFiltersComponent = (
        <OfflineAccordion
          baseClassName={'pb-offline-books'}
          open={this.state.open}
          isRtl={this.props.isRtl}
          title={t("global.reading-program-select-language")}
          language={stemHomeFilters.language.queryValues}
          toggle={this.toggle}
          onApplyFilter={this.onApplyFilter}
          appliedFilters={appliedFilters}
          books = {stemHomeBooks}
        />
      )
    }

    return (
      <OfflineBooks
        userId={userId}
        userType={userType}
        userEmail={userEmail}
        viewport={viewport}
        books={books}
        editActive={editActive}
        onManage={this.enableEditMode}
        onCancel={this.disableEditMode}
        onDelete={this.onDelete}
        onChangeCheckedValues={this.onChangeCheckedValues}
        onChangeCheckedTranslateValues={this.onChangeCheckedTranslateValues}
        online={online}
        isSomethingSelected={activeTabIndex === 4 ? Boolean(checkedTranslateValues.length) : activeTabIndex === 3 ? Boolean(stemCheckedValues.length) : activeTabIndex === 2 ? Boolean(flpCheckedValues.length) : (activeTabIndex === 1 ? Boolean(themeCheckedValues.length)  : Boolean(checkedValues.length))}
        checkedValues={checkedValues}
        themeCheckedValues={themeCheckedValues}
        flpCheckedValues={flpCheckedValues}
        stemCheckedValues={stemCheckedValues}
        onChangeCheckedThemeValues={this.onChangeCheckedThemeValues}
        onChangeCheckedFlpValues={this.onChangeCheckedFlpValues}
        onChangeCheckedStemValues={this.onChangeCheckedStemValues}
        onReadingTabDelete={this.onReadingTabDelete}
        onFlpTabDelete={this.onFlpTabDelete}
        onStemTabDelete={this.onStemTabDelete}
        checkedThemeBooks={checkedThemeBooks}
        checkedTranslateValues={checkedTranslateValues}
        readBooks={readBooks}
        readingProgramBooks={readingProgramBooks}
        flpHomeBooks={flpHomeBooks}
        activeTabIndex={activeTabIndex}
        onTabChange={onTabChange}
        isRtl={this.props.isRtl}
        offlineTranslateBooks={offlineTranslateBooks}
        openOfflineTranslation={this.openOfflineTranslation}
        onTabChangeUrl={this.onTabChangeUrl}
        isOfflineTranslatorVisible={isOfflineTranslatorVisible}
        filtersComponent={filtersComponent}
        flpHomeFiltersComponent={flpHomeFiltersComponent}
        stemHomeFiltersComponent={stemHomeFiltersComponent}
        rpLanguageSelectedBooks={readingProgramBooks}
        rpLanguages={this.state.appliedFilters.language[0]}
        stemLpData={stemLpData}
        stemHomeBooks={stemHomeBooks}
        onTriggerEvents={this.onTriggerEvents}
        openAuthModal={openAuthModal}
        isLoggedIn={this.props.isLoggedIn}
        isFetchingMe={this.props.isFetchingMe}
      />
    );
  }
}

export default translate()(OfflineBooksContainer);



// WEBPACK FOOTER //
// ./src/components/OfflineBooksContainer/OfflineBooksContainer.jsx